<app-breadcrumbs [headerTitle]="'LEGAL ENTITIES'" />
<div class="main-container">
	<app-customer-list id="customer-list" (newCustomerSelectedEvent)="customerSelected($event)"></app-customer-list>
</div>
